import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Icon from "../Icon";
import Tooltip from "../Tooltip";
import styles from './EditorUserTypeIcon.scss';

var EditorUserTypeIcon = function EditorUserTypeIcon(_ref) {
  var size = _ref.size,
      className = _ref.className,
      onClick = _ref.onClick;

  var _useTranslation = useTranslation('commonUi'),
      t = _useTranslation.t;

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.EditorUserTypeIcon, className)
  }, /*#__PURE__*/React.createElement(Tooltip, {
    controlElement: /*#__PURE__*/React.createElement(Icon, {
      name: "round-check",
      color: "accent",
      size: size,
      onClick: onClick
    })
  }, /*#__PURE__*/React.createElement(Tooltip.Item, {
    label: t('EDITOR_USER_TYPE_LABEL')
  })));
};

export default EditorUserTypeIcon;